/* 🤖 this file was generated by svg-to-ts */
export const siriusDotsThreeHorisontal: {
  name: 'dots_three_horisontal';
  data: string;
} = {
  name: 'dots_three_horisontal',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM9 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM19.5 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM18 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" fill="currentColor"/></svg>`
};
